module.exports = __webpack_public_path__ + "img/close.35044866.svg";